<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ t('patients::page.title.dispensed_patients') }}</h2>
            <dispensed-patients-data-table
                :list-route="listRoute"
                :initial-filters="initialFilters"
            ></dispensed-patients-data-table>
        </v-col>
    </div>
</template>

<script>
import DispensedPatientsDataTable from './partials/DispensedPatientsDataTable.vue';

export default {
    components: { DispensedPatientsDataTable },
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            initialFilters: {
                is_registered: 1,
            },
        };
    },
};
</script>
